import { finalize } from 'rxjs/operators';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ChatService  } from 'src/app/services/chat.service';
import { OfferModel, ProductModel } from './../../models/wardrobe.model';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { OfferSuccessModalComponent } from '../offer-success-modal/offer-success-modal.component';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { OfferDetailModel } from './../../models/wardrobe.model';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'shc-swap-request-modal',
  templateUrl: './cancel-swap-request-modal.component.html',
  styleUrls: ['./cancel-swap-request-modal.component.scss'],
})
export class CancelSwapRequestComponent implements OnInit {
  price: number;
  userId: number;
  form: UntypedFormGroup;
  offer: OfferModel;
  @Input() senderId: number;
  optionalPrices: Array<number>;
  @Input() product: ProductModel;
  @Input() actualProductId: ProductModel;
  @Input() offerItem: OfferDetailModel;
  @Input() chatId: string;
  @Input() isRequester = true;

  constructor(
    private modalCtrl: ModalController,
    private userService: UserService,
    private errorService: ErrorHandlerService,
    private translate: TranslateService,
    private chatService: ChatService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    this.userService.get().subscribe(res => {
      this.userId = res.id;
    });
    console.log("[this.chatId]: ", this.chatId);
    this.form = new UntypedFormGroup({
      // product_id: new FormControl(this.product?.id || null),
      product_id: new UntypedFormControl(this.actualProductId || null),
      sent_by: new UntypedFormControl(this.product?.user?.id || null),
      sent_to: new UntypedFormControl(this.senderId)
    });
  }

  cancelSwapRequest() {
    // [TODO]   We need a offer id instead of product id
    // [TODO]   Get offer ID and pass variable
    console.log("[this.chatId ln 58]: ", this.chatId);
    this.chatService.cancelChat(this.chatId).subscribe(res => {
      this.modalCtrl.dismiss(this.offerItem, null, 'cancelSwapRequest');
      this.errorService.showToast(this.translate.instant(marker('CancelSwapRequest.Canceled')));
      this.router.navigate(['tabs', 'chat']);
    }, error => {
      this.errorService.handle(error);
    });

    // Pass the offer & product
    // Send request to backend for canceling swap request
    // Send user back to product page?
    // console.log("Hello, world");

  }

  async successModal() {
    const modal = await this.modalCtrl.create({
      component: OfferSuccessModalComponent,
      cssClass: 'offer-success-modal',
      canDismiss: true,
      id: 'offerSuccess'
    });
    modal.onDidDismiss().then((data) => {
      console.log(this.offer);
      this.modalCtrl.dismiss(this.offer, null, 'cancelSwapRequest');
    });
    return await modal.present();
  }

  closeModal() {
    this.modalCtrl.dismiss(null, null, 'cancelSwapRequest');
  }

}
